import React, { useEffect, useState } from 'react';

import AssetLibrary from '../../../../shared/components/AssetLibrary/AssetLibrary';
import AssetService from '../../../../shared/services/AssetService';
import ColorPickerDialog from '../../../../shared/components/ColorPickerDialog';
import ColorPickerService from '../../../../shared/services/ColorPickerService';
import Grid from '@mui/system/Unstable_Grid';
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import PickerResetButton from '../../../../shared/components/PickerResetButton';
import { RgbaColor } from '../../../models/LessonComponentStyle';
import styles from '../../../styles/Timeline.module.scss';

interface ItemIconProps {
  color?: RgbaColor | string;
  resetButton?: boolean;
  disabled?: boolean;
  assetkey?: string;
  icon?: boolean;
  onChange: (value: RgbaColor | string) => void;
}

export default function ItemIcon(props: ItemIconProps) {
  const { color, icon, disabled, assetkey } = props;
  const [showColorPickerDialog, setShowColorPickerDialog] = useState(false);
  const [rgbaColor, setRgbaColor] = useState<RgbaColor>(null);
  const [showAssetLibrary, setShowAssetLibrary] = useState(false);

  const src = AssetService.getAssetUrl(assetkey);

  useEffect(() => {
    if (color) {
      const rgba = ColorPickerService.hexToRgbA(color as string);
      setRgbaColor(rgba);
    }
  }, [color]);

  const handleClick = () => {
    setShowColorPickerDialog(true);
  };

  const handleReset = () => {
    props.onChange(null);
  };

  const handleClose = (rgba?: RgbaColor) => {
    if (rgba) {
      props.onChange(ColorPickerService.rgbToHex(rgba));
    }
    setShowColorPickerDialog(false);
  };

  const handleAssetSelect = (assetkey: string) => {
    props.onChange(assetkey);
  };

  return (
    <>
      <Grid container alignItems="center">
        {icon ? (
          <Grid style={{ position: 'relative' }}>
            {src ? (
              <img
                className={styles.iconThumbnail}
                src={src}
                onClick={() => {
                  setShowAssetLibrary(true);
                }}
              />
            ) : (
              <IconButton
                size="small"
                onClick={() => {
                  setShowAssetLibrary(true);
                }}
                sx={{ padding: 0 }}
              >
                <ImageIcon />
              </IconButton>
            )}
          </Grid>
        ) : (
          <Grid onClick={handleClick}>
            <div
              className={`color-picker-button-round `}
              style={{
                backgroundColor: color ? (color as string) : '',
                cursor: 'pointer'
              }}
            ></div>
          </Grid>
        )}
        <Grid>
          <PickerResetButton disabled={disabled} onReset={handleReset} />
        </Grid>
      </Grid>
      {showColorPickerDialog && (
        <ColorPickerDialog color={rgbaColor} onClose={handleClose} />
      )}
      {showAssetLibrary && (
        <AssetLibrary
          types={['image']}
          category="author"
          title="Select Image"
          selectedAssetkey={assetkey}
          onSelect={handleAssetSelect}
          onClose={() => setShowAssetLibrary(false)}
        />
      )}
    </>
  );
}
